module.exports = __webpack_public_path__ + "static/media/contribute.552c3589.png";